import { createApiRef } from '@backstage/core-plugin-api';
import type {
  EntityPreviewCreateResponse,
  EntityPreviewListResponse,
  EntityPreviewGetResponse,
} from '@schibsted/backstage-plugin-entity-preview-common';

export interface EntityPreviewApi {
  createPreview(
    yaml: string,
    editingEntityId?: string,
  ): Promise<EntityPreviewCreateResponse>;
  listEntities(): Promise<EntityPreviewListResponse>;
  getEntity(id: string): Promise<EntityPreviewGetResponse>;
  deleteEntity(id: string): Promise<void>;
}

export const entityPreviewApiRef = createApiRef<EntityPreviewApi>({
  id: 'plugin.entity-preview.api',
});
